import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import ReCAPTCHA from 'react-google-recaptcha';
import toast, { Toaster } from 'react-hot-toast';
import { 
  Grid,
  GridRow,
  GridColumn, 
  Header, 
} from 'semantic-ui-react';

const buttonFormStyle = {
  backgroundColor: 'transparent',
  borderColor: '#8C8C8C',
  borderRadius: '5px',
  borderWidth: '0.2em',
  borderStyle: 'solid',
  color: '#8C8C8C',
  paddingTop: '0.8em',
  paddingBottom: '0.8em',
  paddingLeft: '3em',
  paddingRight: '3em',
  fontWeight: 'bold',
  cursor: 'pointer',
  fontFamily: "'Andika', sans-serif",
};

const buttonFormStyleHover = {
  ...buttonFormStyle,
  borderColor: '#92A082',
  color: '#92A082',
};

const inputStyle = {
  background: 'transparent',
  border: '0.2em solid #8C8C8C',
  borderRadius: '5px',
  color: '#8C8C8C',
  lineHeight: '35px',
  marginBottom: '25px',
  paddingLeft: '1em',
  width: '100%',
  fontFamily: "'Andika', sans-serif",
}

const textAreaStyle = {
  ...inputStyle, 
  height: '150px',  
}

const h1Style = {
  fontFamily: "'Andika', sans-serif",
  color: "#8C8C8C",
  fontSize: "4em",
}

const h1StyleMobile = {
  fontFamily: "'Andika', sans-serif",
  color: "#8C8C8C",
  fontSize: "3em",
}

export const ContactForm = () => {
  const form = useRef();
  const [hoveredFormSubmit, setHoveredFormSubmit] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState(null);

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
  };

  const sendEmail = (e) => {
    e.preventDefault();
    if (recaptchaValue) {
      emailjs
        .sendForm('service_tjepx0w', 'template_bhsa3qq', form.current, {
          publicKey: 'D4obohlGKanuQuTIi',
        })
        .then(
          () => {
            toast.success('Email sent successfully!');
            console.log('SUCCESS!');
          },
          (error) => {
            toast.error(`Email sending failed: ${error.text}`);
            console.log('FAILED...', error.text);
          },
        );
    } else {
      toast.error('Please complete the reCAPTCHA');
      console.log('Please complete the reCAPTCHA');
    }
  };

  const placeholderColor = '#8C8C8C';

  return (
    <div 
      style={{ 
        display: 'block', 
        textAlign: 'center',
        padding: '0em 0em 10em 0em', 
      }}>
      <Toaster />
      <Grid>
        <GridRow columns={1} style={{padding: "10em 0em 2em 0em" }}>
          <GridColumn only="computer tablet" textAlign='center'>
            <Header
              as='h1'
              content='Contact Us'
              id="contact-form-header"
              style={h1Style}
            />
          </GridColumn>
          <GridColumn only="mobile" textAlign='center'>
            <Header
              as='h1'
              content='Contact Us'
              id="contact-form-header"
              style={h1StyleMobile}
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <form
        id="contact-form"
        ref={form}
        onSubmit={sendEmail}
        style={{ 
          display: 'inline-block', 
          padding: '4em 1em 0em 1em',
        }}
      >
        <style>
          {`
            .input-placeholder::placeholder {
              color: ${placeholderColor};
            }
          `}
        </style>
        <input
          type="text"
          name="user_name"
          placeholder="Name"
          aria-label="Your name"
          className="input-placeholder"
          style={inputStyle}
        />
        <input
          type="text"
          name="user_company"
          placeholder="Company name"
          aria-label="Your company name"
          className="input-placeholder"
          style={inputStyle}
        />
        <input
          type="text"
          name="user_phone"
          placeholder="Phone"
          aria-label="Your phone number"
          className="input-placeholder"
          style={inputStyle}
        />
        <input
          type="email"
          name="user_email"
          placeholder="Email"
          aria-label="Your email address"
          className="input-placeholder"
          style={inputStyle}
        />
        <textarea
          name="message"
          placeholder="Tell us about what you are looking for"
          aria-label="Your message"
          className="input-placeholder"
          style={textAreaStyle}
        />
        <ReCAPTCHA
          sitekey="6Ld7lSUqAAAAALbwiGUXmiHhyZUMFk2FESTad1bS"
          onChange={handleRecaptchaChange}
          style={{ marginBottom: '20px' }}
        />
        <input
          type="submit"
          value="Send"
          content="Send"
          onMouseEnter={() => setHoveredFormSubmit(true)}
          onMouseLeave={() => setHoveredFormSubmit(false)}
          style={hoveredFormSubmit ? buttonFormStyleHover : buttonFormStyle}
        />
      </form>
    </div>
  );
};